module.exports = __webpack_public_path__ + "static/qr-code-804e750906efe73b53295fe3abe7fd24.gif";